import React from 'react'
import { IconButton, Box } from '@mui/material'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'

import EnvironmentConfig from './EnvironmentConfig/EnvironmentConfig'
import {
  ContentHeader,
  PageTitle,
} from '../../../styles/MainMenu.styles'
import { MainMenuSection } from '../../types/MainMenu.types'

interface AdminEnvironmentConfigProps {
  onSectionChange: (section: MainMenuSection) => void
}

/**
 * Admin Environment Config Component
 * Environment configuration settings
 */
const AdminEnvironmentConfig: React.FC<AdminEnvironmentConfigProps> = ({
  onSectionChange,
}) => {
  return (
    <>
      <ContentHeader>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <IconButton onClick={() => onSectionChange('adminMenu')}>
            <ArrowBackIcon />
          </IconButton>
          <PageTitle>Environment Configuration</PageTitle>
        </Box>
      </ContentHeader>
      <EnvironmentConfig />
    </>
  )
}

export default AdminEnvironmentConfig 